import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import type { UserProfileSplitData } from '@lib/store';
import { AddressEnum } from './DetailsEditor';
import { Block } from './Block';
import { InputPreview, Select, TextInput } from '@shared/widgets';

interface AddressProps {
  data: UserProfileSplitData | null;
  type: AddressEnum;
  approval: boolean;
  readOnly: boolean;
}

export const Address = (props: AddressProps) => {
  const { t } = useTranslation('profile');

  const TextField = props.approval || props.readOnly ? InputPreview : TextInput;
  const SelectField = props.approval || props.readOnly ? InputPreview : Select;

  if (!props.data) return null;
  return (
    <Block title={t('personalDetails.address.title', { type: t(`personalDetails.address.type.${props.type.toLowerCase()}`) })}>
      <TextField
        value={props.data?.address1 ? props.data?.address1 : '-'}
        caption={t('personalDetails.address.placeholders.addressLine', { number: 1 })}
      />
      <TextField
        value={props.data?.address2 ? props.data?.address2 : '-'}
        caption={t('personalDetails.address.placeholders.addressLine', { number: 2 })}
      />
      <div className='-ml-[10px] -mr-[10px] flex'>
        <TextField
          value={props.data?.city ? props.data?.city : '-'}
          className='w-full md:w-2/3 px-[10px]'
          caption={t('personalDetails.address.placeholders.townCity')}
        />
        <TextField
          className='w-full md:w-1/3 px-[10px]'
          caption={t('personalDetails.address.placeholders.postcode')}
          value={props.data?.postCode ? props.data?.postCode : '-'}
        />
      </div>
      <SelectField
        className={clsx('insignia-cards-profile-address__select', 'w-full')}
        caption={t('personalDetails.address.placeholders.country')}
        value={props.data?.country ? props.data?.country : '-'}
      />
    </Block>
  );
};
